<template>
  <div class="container">
    <div class="row center-xs">
      <div class="col-sm-10 col-md-7 col-xs-12">
        <div class="brdr-cl-primary">
          <div v-if="getGroupedByPartnerProducts && getGroupedByPartnerProducts.length" class="checkout serif cl-accent">
            <p class="summary-total align-center weight-500 medium">{{ $t('Order amount') }}</p>
            <div class="row">
              <template>
                <div class="col-xs inline-flex fs16 weight-700 total-price-label pb10">
                  {{ $t('Subtotal incl. tax') }}
                  <span class="separator col-xs ml10 bottom"></span>
                </div>
                <div class="align-right fs16 total-price-value bold">
                  {{ subtotal | price }}
                </div>
              </template>
            </div>
            <div class="row shipping-row">
              <template v-if="!allMethodsArePickup">
                <div class="col-xs inline-flex fs16 weight-700 total-price-label pb10">
                  {{ $t('Delivery') }}

                  <span class="separator col-xs ml10 bottom"></span>
                </div>
                <div class="align-right fs16 total-price-value bold">
                  <order-delivery-price :price="deliveryPrice" @add-address="handleClickAddAddress" />
                </div>
              </template>
            </div>
            <div v-if="isFeeAdded" class="row shipping-row">
              <template>
                <div class="col-xs inline-flex fs16 weight-700 total-price-label pb10">
                  {{ $t('Fee') }} (2,3%)
                  <span class="separator col-xs ml10 bottom"></span>
                </div>
                <template v-if="isFeeLoading">
                  <span class="skeleton fee" />
                </template>
                <div v-else class="align-right fs16 total-price-value bold" >
                  {{ ipayFee| price }}
                </div>
              </template>
            </div>
            <div v-if="isCheckoutPage && hasServiceFee" class="row shipping-row">
              <template>
                <div class="col-xs inline-flex fs16 weight-700 total-price-label pb10">
                  {{ $t('Service Fee') }}
                  <span class="separator col-xs ml10 bottom"></span>
                </div>
                <div class="align-right fs16 total-price-value bold" >
                  {{ serviceFee| price }}
                </div>
              </template>
            </div>
            <div class="row middle-xs pt20 mb20 brdr-top-1 brdr-cl-white">
              <div class="col-xs inline-flex h4 total-price-label bold">
                {{ $t('Total') }}
                <span class="separator col-xs ml10 bottom"></span>
              </div>
              <template v-if="isFeeLoading">
                <span class="skeleton total" />
              </template>
              <div v-else class="align-right fs16 bold total-price-value">
                {{ orderTotal | price }}
              </div>
            </div>
          </div>
          <bounce-loader v-else style="margin-bottom: 40px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CartSummary } from '@vue-storefront/core/modules/checkout/components/CartSummary'
import BounceLoader from 'theme/components/theme/blocks/Home/Preloaders/BounceLoader'

const OrderDeliveryPrice = () => import(/* webpackChunkName: "vsf-order-delivery-price" */ 'theme/components/core/blocks/Checkout/OrderDeliveryPrice.vue');

export default {
  data () {
    return {
      loadingTotals: true,
      replaceOutOfStock: true,
      contactToReplace: true,
      activeItem: {}
    }
  },
  props: {
    shippingMethods: {
      type: Array,
      required: false,
      default: () => []
    },
    deliveryPrice: {
      type: Number,
      default: null
    },
    place: {
      type: String,
      required: false,
      default: 'review'
    }
  },
  computed: {
    allMethodsArePickup () {
      return this.shippingMethods.every(shipping => shipping.method.method_code === 'pickup')
    },
    orderTotal () {
      if (this.deliveryPrice == null) return null
      const serviceFee = this.isCheckoutPage && this.hasServiceFee ? this.serviceFee : 0
      return this.subtotal + serviceFee + this.deliveryPrice + this.ipayFee
    }
  },
  methods: {
    toggleActive (item) {
      if (this.activeItem[item.id]) {
        this.removeActiveItem(item);
        return;
      }
      this.addActiveItem(item);
    },
    addActiveItem (item) {
      this.activeItem = Object.assign({},
        this.activeItem,
        [item.id] = item
      );
    },
    removeActiveItem (item) {
      delete this.activeItem[item.id];
      this.activeItem = Object.assign({}, this.activeItem);
    },
    updateDeliveryPrice (selectedDateTime, v, deliveryTimeOption, partnerCode,shippingMethod, nextPartnerCode) {
      this.getGroupedByPartnerProducts.forEach(group => {
        if (group.partner.code === partnerCode && shippingMethod.method_code === 'pickup') {
          group.delivery = 0
        } else if (group.partner.code === partnerCode && shippingMethod['amount']) {
          group.delivery = shippingMethod['amount']
        }
      })
    },
    handleClickAddAddress () {
      this.$bus.$emit('scroll-to-the-address-form');
    }
  },
  beforeMount () {
    this.$bus.$on('checkout-after-deliveryTimeDetails', this.updateDeliveryPrice)
  },
  beforeDestroy () {
    this.$bus.$off('checkout-after-deliveryTimeDetails', this.updateDeliveryPrice)
  },
  components: {
    OrderDeliveryPrice,
    BounceLoader
  },
  mixins: [CartSummary]
}
</script>

<style lang="scss" scoped>
.skeleton {
  animation: skeleton-loading 1s linear infinite alternate;
  object-fit: cover;
  flex-shrink: 0;
  display: inline-flex;
  border-radius: 4px;
  margin: 0 8px;

  &.fee {
    width: 68px;
    height: 19px;
  }

  &.total {
    width: 92px;
    height: 19px;
  }
}

.replace-option {
  width: 45%;
  display: inline-block;
}
.shipping-row {
  .shipping-row-child {
    color: #11bb2e;
    text-align:right;
  }
}
.summary-title {
  @media (max-width: 768px) {
    margin-left: 0;
  }
}
.loading__wrapper {
  svg {
    margin: 0 auto;
  }
}
.loader__text {
  span {
    margin: 0 auto;
  }
}
.partner-block{
  border-bottom-color: #fff;
  cursor: default;
}
.checkout {
  cursor: default;
}
.toogle-button{
  color: #fff;
  background-color: #11bb2e;
  border-radius: 10px;
  text-align: center;
}
.separator.bottom {
  border-bottom: 1px dashed rgba(17, 17, 17, 0.11);
  height: 15px;
}

@keyframes skeleton-loading {
  0% {
    background-color: hsl(60, 6%, 94%);
  }
  100% {
    background-color: hsl(0, 0%, 85%);
  }
}
</style>
